<template lang="pug">
section.section.border-bottom-section
	.section-content
		.columns.is-centered.is-vcentered.columns-text-title-left
			.column
				.title.is-spaced.has-text-centered {{ $t('about.title4') }}
				ul.subtitle
					li {{ $t('about.content4_l1') }}
					li {{ $t('about.content4_l1_2') }}
					li
						| {{ $t('about.content4_l2') }}
						ol
							li {{ $t('about.content4_l2_1') }}
							li {{ $t('about.content4_l2_2') }}
					li {{ $t('about.content4_l3') }}
					li {{ $t('about.content4_l4') }}
</template>

<script>
export default {
	name: 'SectionCompany'
}
</script>
